import { render, staticRenderFns } from "./AddNewUserDialog.vue?vue&type=template&id=0952a912&scoped=true"
import script from "./AddNewUserDialog.vue?vue&type=script&lang=js"
export * from "./AddNewUserDialog.vue?vue&type=script&lang=js"
import style0 from "./AddNewUserDialog.vue?vue&type=style&index=0&id=0952a912&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0952a912",
  null
  
)

export default component.exports